import { cloneDeep } from 'lodash';
import { PrescriptionNodeValue } from 'src/app/shared/models/prescription/prescription-node-value.model';
import { PrescriptionRequestDto } from 'src/app/shared/models/prescription/prescription-request-dto.model';

import { PrescriptionChainHandler } from './prescription-chain-handler';

export class Max3ArticlesPerPrescriptionHandler extends PrescriptionChainHandler {
  async handleRequest(prescriptionRequestDto: PrescriptionRequestDto, request: PrescriptionNodeValue) {
    const splitPrescriptionRequests = [];
    const toRemovePrescriptionIndex = [];
    for (const prescription of prescriptionRequestDto.prescriptions) {
      if (prescription.positions.length > 3) {
        const chunkSize = 3;
        const currentPresciption = prescriptionRequestDto.prescriptions[0];
        for (let i = 0; i < prescription.positions.length; i += chunkSize) {
          const chunk = prescription.positions.slice(i, i + chunkSize);
          const additionalPrescription = cloneDeep(currentPresciption);

          // we need to set the medicalAidPrescription and tubeFeedingNutrition for the additionalPrescription
          // because it is cloned from the prescriptionRequestDto.prescriptions[0] which does not have these properties
          // properly set for the current prescription
          additionalPrescription.medicalAidPrescription = prescription.medicalAidPrescription;
          additionalPrescription.tubeFeedingNutrition = prescription.tubeFeedingNutrition;

          additionalPrescription.positions = chunk;
          splitPrescriptionRequests.push(additionalPrescription);
        }
        toRemovePrescriptionIndex.push(prescriptionRequestDto.prescriptions.indexOf(prescription));
      }
    }
    prescriptionRequestDto.prescriptions = prescriptionRequestDto.prescriptions.filter(
      (_, index) => !toRemovePrescriptionIndex.includes(index)
    );
    prescriptionRequestDto.prescriptions.push(...splitPrescriptionRequests);
    return this.next.handleRequest(prescriptionRequestDto, request);
  }
}
